/* ============================================================
   MLVINCE custom.js — 全カスタムスクリプト集約（Prestige v11.4.0）
   規約: テーマ本体JSは編集しない。ここに追記のみ。
   ============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  // 機能単位の IIFE で追記する

  /* ===== ルックブック: スクロールリビール =====
     縦に長いページが単調にならないよう、画像を視界に入ったタイミングで静かに立ち上げる。
     prefers-reduced-motion 時と非対応ブラウザでは何もしない（常時表示のまま）。 */
  (function () {
    const items = document.querySelectorAll('.mlv-lookbook__item');
    if (!items.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduced && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('mlv-reveal--in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      const vh = window.innerHeight;
      items.forEach((el) => {
        el.classList.add('mlv-reveal');
        // 初期ビューポート内はIOを待たず即表示（初回描画がIOのタイミングに依存しないための保険）
        if (el.getBoundingClientRect().top < vh * 0.92) {
          el.classList.add('mlv-reveal--in');
        } else {
          io.observe(el);
        }
      });
    }
  })();

  /* ===== ルックブック: ライトボックス =====
     画像クリックで拡大。← → で前後、Esc/背景クリックで閉じる、スマホは横スワイプで送る。 */
  (function () {
    const imgs = Array.from(document.querySelectorAll('.mlv-lookbook__item img'));
    if (!imgs.length) return;

    const lb = document.createElement('div');
    lb.className = 'mlv-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Lookbook viewer');
    lb.innerHTML =
      '<img class="mlv-lb__img" alt="">' +
      '<div class="mlv-lb__counter" aria-hidden="true"></div>' +
      '<button class="mlv-lb__btn mlv-lb__prev" type="button" aria-label="Previous">&#8249;</button>' +
      '<button class="mlv-lb__btn mlv-lb__next" type="button" aria-label="Next">&#8250;</button>' +
      '<button class="mlv-lb__btn mlv-lb__close" type="button" aria-label="Close">&#215;</button>';
    document.body.appendChild(lb);
    const lbImg = lb.querySelector('.mlv-lb__img');
    const lbCounter = lb.querySelector('.mlv-lb__counter');
    let idx = 0;

    const largeSrc = (img) => {
      const url = img.currentSrc || img.src;
      return /[?&]width=/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=1800') : url;
    };
    const pad = (n) => String(n).padStart(2, '0');
    // 2026-09-04: <img> に新しい src を入れても読み込み完了まで前の画像が残るため、
    // 切替時は前の画像を即座に消し（is-loaded を外す＋src を空に）、読み込み完了後にフェードインさせる。
    // 連打時の追い越しは token で判定し、最後に要求した画像だけを表示する。
    let loadToken = 0;
    const show = (i) => {
      idx = (i + imgs.length) % imgs.length;
      const target = largeSrc(imgs[idx]);
      const token = ++loadToken;
      lbImg.classList.remove('is-loaded');
      lbImg.removeAttribute('src');
      lbImg.alt = imgs[idx].alt || '';
      lbCounter.textContent = pad(idx + 1) + ' / ' + pad(imgs.length);
      const pre = new Image();
      pre.onload = () => {
        if (token !== loadToken) return; // 追い越された要求は捨てる
        lbImg.src = target;
        lbImg.classList.add('is-loaded');
      };
      pre.src = target;
      // 前後の先読み
      [idx + 1, idx - 1].forEach((j) => { new Image().src = largeSrc(imgs[(j + imgs.length) % imgs.length]); });
    };
    const open = (i) => { show(i); lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
    const close = () => {
      lb.classList.remove('is-open'); document.documentElement.style.overflow = '';
      loadToken++; // 閉じた後に届く読み込みは表示しない
      lbImg.classList.remove('is-loaded');
      lbImg.removeAttribute('src'); // 次に開くとき前の画像が一瞬見えないように破棄
    };

    imgs.forEach((img, i) => img.addEventListener('click', () => open(i)));
    lb.querySelector('.mlv-lb__close').addEventListener('click', close);
    lb.querySelector('.mlv-lb__prev').addEventListener('click', () => show(idx - 1));
    lb.querySelector('.mlv-lb__next').addEventListener('click', () => show(idx + 1));
    lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
    document.addEventListener('keydown', (e) => {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });
    let touchX = null;
    lb.addEventListener('touchstart', (e) => { touchX = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', (e) => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 48) { dx < 0 ? show(idx + 1) : show(idx - 1); }
    }, { passive: true });
  })();

  /* ===== 商品カード: タッチ端末でも「触れている間」はホバー画像を見せる（2026-09-04） =====
     Prestige はセカンダリ画像を pointer:fine（マウス）でしか出さない。
     指が乗っているカード（スクロール中に指の下を通るカードも）にホバー状態を与え、
     指を離したら戻す。タップは通常どおり遷移する。
     セカンダリ画像は触れた時に初めて display:block になる（lazy 画像を無駄に読まない）。 */
  (function () {
    if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
    var CLS = 'mlv-touch-hover', SHOWN = 'mlv-touch-hover--shown';
    var active = null;

    function figureFrom(el) {
      var fig = el && el.closest ? el.closest('.product-card__figure') : null;
      return fig && fig.querySelector('.product-card__image--secondary') ? fig : null;
    }
    function reveal(fig) {
      var img = fig.querySelector('.product-card__image--secondary');
      if (img.loading === 'lazy') img.loading = 'eager'; // 触れた瞬間に読み込みを始める（lazy待ちにしない）
      clearTimeout(fig._mlvHideTimer);
      fig.classList.add(CLS);
      var show = function () {
        if (active !== fig) return;
        void img.offsetWidth; // display:block を先に確定させ、続く opacity 変化をトランジションさせる
        fig.classList.add(SHOWN);
      };
      if (img.complete && img.naturalWidth > 0) show();
      else img.addEventListener('load', show, { once: true });
    }
    // 戻りも同じクロスフェード: まず SHOWN を外して 1枚目↔2枚目を入れ替え、
    // フェードが終わってから 2枚目を display:none に戻す（即時に消すと白背景が透けて光って見える）
    var FADE_MS = 380;
    function hide(fig) {
      fig.classList.remove(SHOWN);
      clearTimeout(fig._mlvHideTimer);
      fig._mlvHideTimer = setTimeout(function () {
        if (active !== fig) fig.classList.remove(CLS);
      }, FADE_MS);
    }
    function moveTo(fig) {
      if (fig === active) return;
      if (active) hide(active);
      active = fig;
      if (fig) reveal(fig);
    }
    function end() { if (active) hide(active); active = null; }

    document.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      moveTo(figureFrom(e.target));
    }, { passive: true });
    document.addEventListener('touchmove', function (e) {
      if (e.touches.length !== 1) return;
      var t = e.touches[0];
      moveTo(figureFrom(document.elementFromPoint(t.clientX, t.clientY)));
    }, { passive: true });
    document.addEventListener('touchend', end, { passive: true });
    document.addEventListener('touchcancel', end, { passive: true });
  })();

  /* ===== 再入荷通知 STOQ: バリアント切替後に WAITLIST ボタンを再描画（2026-09-07） =====
     Prestige は variant:change と同時に buy-buttons を丸ごと再描画（差し替え）する。
     STOQ は [name=id] の change を拾って旧 buy-buttons にボタンを挿すため、差し替えと同時に消えてしまい、
     「在庫ありのバリアントから品切れバリアントを選ぶとボタンが出ない」不具合になる（直接URLなら初期描画で出る）。
     → 再描画が済んだ後に STOQ 公式の renderButtonForVariant() で描き直す。既にボタンがあれば何もしない（二重挿入防止）。
     在庫ありバリアントでは STOQ 側が描画しないので、この処理は品切れ時だけ効く。 */
  (function () {
    var timers = [];
    document.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.id) return;
      // 切替が連続したら前回の予約は破棄する（古いバリアント用のボタンを後から挿さない）
      timers.forEach(clearTimeout); timers = [];
      var form = e.detail.formId ? document.getElementById(e.detail.formId) : null;
      var render = function () {
        var rr = window._RestockRocket || window._Stoq;
        if (!rr || typeof rr.renderButtonForVariant !== 'function') return;
        // 描画直前に「いま選択中のバリアント」がこのイベントのものと同じか確認する（激しい切替の誤爆防止）
        var idInput = (form || document).querySelector('[name="id"]');
        if (idInput && String(idInput.value) !== String(v.id)) return;
        if (document.querySelector('.restock-rocket-button-container')) return;
        rr.renderButtonForVariant(v.id);
      };
      // 差し替えは variant:change の直後（数ms）に走る。少し待ってから描き、念のため後段でもう一度確認する
      timers.push(setTimeout(render, 150), setTimeout(render, 700));
    });
  })();
});
